import { lazy, Suspense } from "react";
import CircularLoader from "../../custom/circularLoader/circularLoader";
import DasboardLayout from "./../dashboardLayout/dashboardLayout";

const Main = lazy(() => import("../../components/Examination-NYSC/ApplicationForm/main"));

const ApplicationForm = () => {
    return (
        <DasboardLayout 
            heading="Application Form"
            paragraph="Fill in your details " 
        >
            <Suspense fallback={<CircularLoader/>}>
                <Main/>
            </Suspense>
        </DasboardLayout>
    )
}
export default ApplicationForm;